import { render, staticRenderFns } from "./NewPricePage.vue?vue&type=template&id=28af7129&scoped=true"
import script from "./NewPricePage.vue?vue&type=script&lang=js"
export * from "./NewPricePage.vue?vue&type=script&lang=js"
import style0 from "./NewPricePage.vue?vue&type=style&index=0&id=28af7129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af7129",
  null
  
)

export default component.exports